<div class="container">
    <p-toast></p-toast>
    <form [formGroup]="assignationForm">
        <div class="row pt-3">
            <div class="col-md-4 mb-3 mt-2">
                <label for="teamTxt">{{ 'assignmentDialog.labels.team' | translate }}</label>
                <div class="p-inputgroup">
                    <input type="text" id="teamTxt" pInputText readonly
                           (click)="searchTeam()"
                           class="w80"
                           formControlName="areaDescription">
                    <button type="button" pButton pRipple icon="pi pi-search"
                            class="p-button-danger" (click)="searchTeam()"></button>
                </div>
                <small class="p-error block"
                       *ngIf="assignationForm.get('areaDescription')?.invalid && assignationForm.get('areaDescription')?.touched">
                    {{ 'assignmentDialog.errors.teamRequired' | translate }}
                </small>
            </div>
            <div class="col-md-4 mb-3 mt-2">
                <label for="responsibleTxt">{{ 'assignmentDialog.labels.responsible' | translate }}</label>
                <div class="p-inputgroup">
                    <input type="text" id="responsibleTxt" pInputText readonly
                           (click)="searchResponsible()"
                           class="w80"
                           formControlName="responsibleName">
                    <button type="button" pButton pRipple icon="pi pi-search"
                            class="p-button-danger" (click)="searchResponsible()"></button>
                </div>
                <small class="p-error block"
                       *ngIf="assignationForm.get('responsibleName')?.invalid && assignationForm.get('responsibleName')?.touched">
                    {{ 'assignmentDialog.errors.responsibleRequired' | translate }}
                </small>
            </div>
            <div class="col-md-4 mb-3 mt-2">
                <label for="customerTxt">{{ 'assignmentDialog.labels.customer' | translate }}</label>
                <div class="p-inputgroup">
                    <input type="text" id="customerTxt" pInputText readonly
                           (click)="searchCustomer()"
                           class="w80"
                           formControlName="customerName">
                    <button type="button" pButton pRipple icon="pi pi-search"
                            class="p-button-danger" (click)="searchCustomer()"></button>
                </div>
            </div>
            <div class="col-md-4 mb-3 mt-2">
                <p>{{ 'assignmentDialog.labels.status' | translate }}</p>
                <p-toggleswitch formControlName="status" id="statusSwitch"></p-toggleswitch>
            </div>
        </div>
    </form>
    <div class="row d-inline-flex float-end">
        <div>
            <p-button type="button" icon="pi pi-save" (click)="saveAssignment()"
                    [label]="'assignmentDialog.buttons.save' | translate"
                    [disabled]="assignationForm.invalid"
                      severity="danger"
                      variant="outlined"
                    class="me-2"></p-button>
            <p-button type="button" icon="pi pi-times" (click)="closeModal()"
                    [label]="'assignmentDialog.buttons.cancel' | translate"
                      severity="danger"></p-button>
        </div>
    </div>
</div>